import { useQuery } from '@tanstack/react-query';

import { fetchSessionUser } from '../api';
import { type User } from '../types';

/**
 * The signed-in admin's own profile (GET /api/users/me). Replaces the web
 * `useUser()` for self-detection — e.g. excluding the admin's own row from the
 * client list, or hiding self-only affordances on the detail page.
 */
export function useSessionUser(): { user: User | undefined; isLoading: boolean } {
  const query = useQuery({
    queryKey: ['session-user'],
    queryFn: fetchSessionUser,
    staleTime: 5 * 60_000,
  });
  return { user: query.data, isLoading: query.isLoading };
}
